export var BOVehicleDetailsKey;
(function (BOVehicleDetailsKey) {
    BOVehicleDetailsKey["year"] = "year";
    BOVehicleDetailsKey["assetType"] = "asset_type_id";
    BOVehicleDetailsKey["make"] = "make_id";
    BOVehicleDetailsKey["model"] = "model_id";
    BOVehicleDetailsKey["option"] = "option_id";
    BOVehicleDetailsKey["vehicleUnitNumber"] = "fleet_id_no";
    BOVehicleDetailsKey["vin"] = "vin";
    BOVehicleDetailsKey["licensePlate"] = "license_plate";
    BOVehicleDetailsKey["licenseState"] = "license_state_abbreviation";
    BOVehicleDetailsKey["color"] = "color";
})(BOVehicleDetailsKey || (BOVehicleDetailsKey = {}));
//# sourceMappingURL=types.js.map